import { IAppContext } from "../model/IAppContext";
import { AuthenticationResult, IPublicClientApplication } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

function linesFromError(error: any): string[]
{
    if (error.stack)
    {
        return [
            //                "Something has gone very wrong.",
            //                "Its not your fault, its mine.",
            //                "It would be great if you would report this problem to me via email at red@traynrex.com.",
            //                "Copy and paste all of the details below.",
            //                "THANK YOU!",
            "Details:",
            `Exception caught: ${error.message}`,
            ...error.stack.split("\n")
        ];
    }
    else
    {
        return [
            //                "Something has gone very wrong.",
            //                "Its not your fault, its mine.",
            //                "It would be great if you would report this problem to me via email at red@traynrex.com.",
            //                "Copy and paste all of the details below.",
            //                "THANK YOU!",
            "Details:",
            `Exception caught: ${error.message}`,
            "BAD DEVELOPER, no stack trace!"
        ];
    }
}


export class WebApiInterop
{
    private m_msalInstance?: IPublicClientApplication;
    private m_sApiRoot: string;
    private m_authToken: string = "";
    private m_appContext: IAppContext;

    constructor(sApiRoot: string, appContext: IAppContext, msalInstance?: IPublicClientApplication)
    {
        this.m_sApiRoot = sApiRoot;
        this.m_appContext = appContext;
        this.m_msalInstance = msalInstance;
    }

    get isAuthenticated(): boolean
    {
        return ((this.m_msalInstance?.getAllAccounts()?.length ?? 0) === 0);
    }

    setMsalInstance(msalInstance: IPublicClientApplication)
    {
        this.m_msalInstance = msalInstance;
    }

    async getAuthToken(): Promise<string | null>
    {
        if (!this.m_msalInstance)
            return null;

        const accounts = this.m_msalInstance.getAllAccounts();

        // if length == 0 then we have to log in
        if (accounts.length === 0)
            return null;

        const account = this.m_msalInstance.getActiveAccount();

        if (!account)
            return null;

        let response: AuthenticationResult | null = null;

        try
        {
            // acquire a token if we are already logged in
            response = await this.m_msalInstance.acquireTokenSilent(
                {
                    ...loginRequest,
                    account: account
                });

            return response.accessToken;
        }
        catch (err)
        {
            if (err instanceof Error)
            {
                if (err?.name === 'InteractionRequiredAuthError')
                {
                    await this.m_msalInstance.acquireTokenRedirect(
                        {
                            ...loginRequest,
                            account: account
                        });

                    // acquire a token if we are already logged in
                    response = await this.m_msalInstance.acquireTokenSilent(
                        {
                            ...loginRequest,
                            account: account
                        });

                    return response.accessToken;
                }
            }
        }
         
        return null;
    }

    async FetchJson(sApi: string, args: any[], needAuth?: boolean): Promise<any>
    {
        let rgs: string[] = [];

        for (var arg of args)
        {
            for (var key in arg)
                rgs.push(`${key}=${arg[key]}`);
        }

        let sCall = this.m_sApiRoot.concat("/", sApi, "?", rgs.join("&"));

        const headerVals: any =
        {
            'Content-Type': 'application/json',
            'Accept': 'application/json' // ,
        };

        if (needAuth)
        {
            const authToken = await this.getAuthToken();

            if (!authToken || authToken === "")
                throw new Error("Failed to get auth token");

            if (authToken)
                headerVals['Authorization'] = "Bearer " + authToken;
        }

        let result: Response = await fetch(
            sCall,
            {
                mode: 'cors',
                headers: headerVals
            });

        if (result.status >= 400)
            throw new Error(`FetchJson failed: (${result.status})`);

        try
        {
            return await result.json();
        }
        catch (e)
        {
            if (e instanceof Error)
            {
                if (e.message.indexOf('end of JSON input') > 0)
                    return null;
            }

            throw (e);
        }
    }

    async FetchJsonWithPost(sApi: string, args: any, needAuth?: boolean): Promise<any>
    {
        let sCall = this.m_sApiRoot.concat("/", sApi);

        const headerVals: any =
        {
            'Content-Type': 'application/json',
            'Accept': 'application/json' // ,
        };

        if (needAuth)
        {
            const authToken = await this.getAuthToken();

            if (!authToken || authToken === "")
                throw new Error("Failed to get auth token");

            if (authToken)
                headerVals['Authorization'] = "Bearer " + authToken;
        }

        let result: Response = await fetch(
            sCall,
            {
                method: 'POST',
                mode: 'cors',
                headers: headerVals,
                body: JSON.stringify(args)
            });

        if (result.status >= 400)
            throw new Error(`FetchJson failed: (${result.status})`);

        try
        {
            return await result.json();
        }
        catch (e)
        {
            if (e instanceof Error)
            {
                if (e.message.indexOf('end of JSON input') > 0)
                    return null;
            }

            throw (e);
        }
    }

    async FetchPost<T>(sApi: string, args: any, errorReturn?: T): Promise<T>
    {
        try
        {
            var json = await this.FetchJsonWithPost(sApi, args);

            return json as T;
        }
        catch (exc)
        {
            if (errorReturn === undefined)
                throw exc;

            this.m_appContext.error([`Failed to call service function ${this.m_sApiRoot}/${sApi}`, `Error: ${exc}`])
            return errorReturn;
        }
    }

    async FetchPostWithAuth<T>(sApi: string, args: any, errorReturn?: T): Promise<T>
    {
        try
        {
            var json = await this.FetchJsonWithPost(sApi, args, true);

            return json as T;
        }
        catch (exc)
        {
            if (errorReturn === undefined)
                throw exc;

            this.m_appContext.error([`Failed to call service function ${this.m_sApiRoot}/${sApi}`, `Error: ${exc}`])
            return errorReturn;
        }
    }

    async Fetch<T>(sApi: string, args: any[], errorReturn?: T): Promise<T>
    {
        try
        {
            var json = await this.FetchJson(sApi, args);

            return json as T;
        }
        catch (exc)
        {
            if (errorReturn === undefined)
                throw exc;

            this.m_appContext.error([`Failed to call service function ${this.m_sApiRoot}/${sApi}`, `Error: ${exc}`, ...linesFromError(exc)])
            return errorReturn;
        }
    }

    async FetchWithAuth<T>(sApi: string, args: any[], errorReturn?: T): Promise<T>
    {
        try
        {
            var json = await this.FetchJson(sApi, args, true);

            return json as T;
        }
        catch (exc)
        {
            if (errorReturn === undefined)
                throw exc;

            this.m_appContext.error([`Failed to call service function ${sApi}`, `Error: ${exc}`, ...linesFromError(exc)])
            return errorReturn;
        }
    }

    removeAuth()
    {
        this.m_authToken = "";
    }

    setAuth(token: string)
    {
        this.m_authToken = token;
    }

    static OptionalParam<T>(key: string, value?: T): any
    {
        if (value === undefined)
            return {};

        return { [key]: value };
    }
}